/** Client-side story lead — mirrors server operationsReportStoryLead */
import type { OperationsReportPayload } from '../../../api/operationsReport'
import { formatCurrency } from '../../../lib/formatters'

function topPendingPayApp(data: OperationsReportPayload) {
  const pending = data.pendingPayments ?? []
  if (!pending.length) return null
  return [...pending].sort(
    (a, b) => (Number(b.days_overdue) || 0) - (Number(a.days_overdue) || 0),
  )[0]
}

/** Top overdue pay app id for follow-ups deep link (?pa=). */
export function pickTopPendingPayAppId(data: OperationsReportPayload): number | null {
  const top = topPendingPayApp(data)
  if (!top) return null
  const id = Number(top.id)
  return Number.isFinite(id) ? id : null
}

export function pickStoryLeadClient(data: OperationsReportPayload): string {
  const pending = data.pendingPayments ?? []
  const outstanding = data.metrics?.outstanding?.value ?? 0
  if (pending.length) {
    const top = topPendingPayApp(data)!
    const days = Number(top.days_overdue) || 0
    const owner = String(top.owner_name || top.project_name || 'An owner')
    const amt = formatCurrency(Number(top.amount_due) || 0)
    return `${owner} owes you ${amt}${days > 0 ? `; oldest check is ${days} days` : ''} — reminders drafted.`
  }
  if (outstanding > 0) {
    return `You have ${formatCurrency(outstanding)} outstanding across your active jobs.`
  }
  return 'Your pipeline is current — Soren is watching lien windows and retainage.'
}
